<button *ngIf="type=='split-btn'" [disabled] ="disabled" pButton pRipple type="button" class="download-btn ey-button-dark me-2 mt-0"
  (click)="menu.toggle($event)" aria-label="download">{{'text.downloadIconLabel' | translate}}
  <i class="ms-1 pi pi-angle-down"></i>
</button>

<p-menu #menu [popup]="true" [model]="splitDownloadItems" appendTo="body">
  <ng-template pTemplate="item" let-item>
    <a class="p-menuitem-link" role="menuitem">
      <span *ngIf="item.icon" class="p-menuitem-icon" [ngClass]="item.icon"></span>
      <span class="p-menuitem-text">{{ item.label }}</span>
      <i *ngIf="item.infoTooltip"
         class="pi pi-info-circle download-menu-info-icon ms-2"
         [pTooltip]="(item.infoTooltip | translate)"
         tooltipPosition="right"
         (click)="$event.stopPropagation(); $event.preventDefault()"
         aria-hidden="true"></i>
    </a>
  </ng-template>
</p-menu>

<button *ngIf="type=='buttonTP'" [disabled] ="disabled" pButton type="button" class="download-btn ey-button-dark me-2 mt-0"
  (click)="downloadExcelTableData()" [label] ="downloadLabelText" icon = "pi pi-download" aria-label="download"> 
</button>